"use client";

// Published landing pages render through Puck's <Render>, so the Puck
// stylesheet is loaded here (scoped to the /<lang>/p/<slug> route) rather than
// globally in the root layout.
import "@puckeditor/core/puck.css";

import { Render } from "@puckeditor/core";
import puckConfig from "@/puck/config";
import type { LandingPuckData } from "@/puck/types";

type LandingPageRenderProps = {
  data: LandingPuckData;
};

export function LandingPageRender({ data }: Readonly<LandingPageRenderProps>) {
  return <Render config={puckConfig} data={data} />;
}
